export const HELP_URL = process.env.EXPO_PUBLIC_HELP_URL;
export const HELP_CONVENIENCE_URL =
  process.env.EXPO_PUBLIC_HELP_CONVENIENCE_URL;
export const HELP_ORGANIZATION_URL =
  process.env.EXPO_PUBLIC_HELP_ORGANIZATION_URL;
export const HELP_REGION_URL = process.env.EXPO_PUBLIC_HELP_REGION_URL;
export const HELP_REGION_MISSING_URL =
  process.env.EXPO_PUBLIC_HELP_REGION_MISSING_URL;
export const HELP_REGION_PARTNER_URL =
  process.env.EXPO_PUBLIC_HELP_REGION_PARTNER_URL;
export const SUPPORT_URL = process.env.EXPO_PUBLIC_SUPPORT_URL;
export const INVITE_URL = process.env.EXPO_PUBLIC_INVITE_URL;
